export default {
    header: {
        company: "Cuprolli Manufacturing srl",
        vatIdLabel: "USt-IdNr",
        vatId: "RO 35671874",
        regComLabel: "Handelsregister",
        regCom: "J2016000468359",
        addressLabel: "Adresse",
        address1: "Strada Caprioarei nr.11",
        address2: "307200 Ghiroda, jud.Timis",
        address3: "Rumänien",
        email: "export@i-struct.eu",
        webLabel: "Web",
        web1: "https://i-struct.at",
        web2: ""
    },
    dateFormat: "DD.MM.YYYY",
    cifLabel: "USt-IdNr",
    emailLabel: "E-Mail",
    phoneLabel: "Tel",
    toLabel: "An",
    byLabel: "Vorgestellt von",
    noLabel: "Nr",
    offerTitle: "PREISANGEBOT",
    quoteTitle: "VORANSCHLAG",
    imgDisclaimer: "Das Foto dient nur zur Veranschaulichung",
    umLabels: {
        kg: 'kg',
        ml: 'Lfm.',
        m2: 'm²',
        buc: 'St.',
        h: 'Std.',
        l: 'L'
    },
    // What a module is called on the offer and in the PDF, keyed by type and variant.
    // framedPanel is a retired type kept for offers that still carry one.
    moduleNames: {
        panel: "Zaunfeld",
        pedestrianGate: "Gartentor",
        pedestrianGateSidePanel: "Gartentor mit Seitenpaneel",
        swingGateSingleLeaf: "Einflügeltor",
        swingGateDoubleLeaf: "Zweiflügeltor",
        swingGateBiFoldSingle: "Einflügeliges Falttor",
        swingGateBiFoldDouble: "Zweiflügeliges Falttor",
        slidingGateSingleLeaf: "Schiebetor",
        slidingGateDoubleLeaf: "Doppelschiebetor",
        slidingGateTelescopic: "Teleskopschiebetor",
        slidingGateArticulated: "Eckschiebetor (90° Winkel)",
        selfSupportingGate: "freitragende Schiebetor",
        posts: "Pfosten",
        post80: "Pfosten 80 × 80 mm",
        post100: "Pfosten 100 × 100 mm",
        post200: "Pfosten 200 × 100 mm",
        framedPanel: "Gerahmte Zaunpaneele"
    },
    moduleLabels: {
        piece: "St.",
        dimensions: "Abmessungen (B x H)",
        area: "Fläche",
        slatWidth: "Profilbreite",
        noProfiles: "Anzahl Profile",
        slatDistance: "Abstand zwischen den Profilen",
        slatDimension: "Profilabmessungen",
        pedestrianGateWidth: "Breite des Fußgängertors",
        height: "Höhe",
        priceArea: "Preis / m²",
        priceLength: "Preis / lfm",
        priceSingle: "Einheitspreis",
        priceTotal: "Gesamtbetrag"
    },
    totalsLabels: {
        currency: "€",
        total: "GESAMT",
        vatIncluded: "Inklusive MwSt.",
        color: "FARBE",
        montageIncluded: "INKLUSIVE MONTAGE",
        montageNotIncluded: "OHNE MONTAGE",
        measureMontageNotInluded: "OHNE AUFMASS UND MONTAGE",
        price_no_VAT_msg: "Der Preis gilt für mehrwertsteuerpflichtige Unternehmen mit einem gültigen Code im MIAS (VIES):",
        price_VAT_msg: "Der Preis für Privatpersonen oder Unternehmen, die nicht für die MwSt. registriert sind:"
    },
    features: {
        featuresTitle: "MERKMALE",
        projectsTitle: "ABGESCHLOSSENE PROJEKTE",
        projectsLink: "https://i-struct.at/projekte",
        list: ["- Alluminiumprofile", "- Pulverbeschichtung", "- Thermisch applizierte Farbe", "- Mechanische Befestigung", "- Ohne Schweißen"]
    },
    extraDetails: {
        title: "Weitere Einzelheiten",
        payment: "Zahlungsbedingungen",
        upfrontPayment: "Anzahlung",
        extraPayment: "zu den Messungen",
        afterPayment: "nach Abschluss der montage.",
        execution: "Ausführungszeit",
        days: "Tage",
        years: "Jahre",
        warranty: "Arbeitsgarantie",
        validOffer: "Gültigkeit des Angebots",
        montageDate: "Arbeitsprogrammierung",
        finalDate: "Fertigstellung der Arbeiten",
        paymentDisclaimer: ""
    },
    nextPage: "Fortsetzung auf nächster Seite",
}